import { Component, OnInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { EmployeeService, EmployeeId } from '../../services/employee.service';
import { DepartmentService } from '../../services/department.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { toast } from 'angular2-materialize';
import { QRCodeComponent } from 'angularx-qrcode';
import { Upload } from '../../services/upload/upload';

@Component({
    selector: 'app-read-employee',
    templateUrl: './read-employee.component.html',
    styleUrls: ['./read-employee.component.css', '../../app.component.css']
})

export class ReadEmployeeComponent implements OnInit, OnDestroy {
    allowed: boolean = false;
    permission: any = {};

    employees: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Folio', className: 'center', name: 'internalKey', sort: 'asc' },
        { title: 'Nombre', name: 'name' },
        { title: 'Apellido', name: 'lastName' },
        { title: 'Correo electrónico', className: 'center', name: 'email' },
        { title: 'Fecha ingreso', className: 'center', name: 'admissionDate' },
        { title: 'Departamento', name: 'departmentName' },
        { title: 'Medio de llegada', name: 'transportArriveName' },
        { title: 'Transportista', name: 'carrierName' },
        { title: 'Acciones', className: 'center w10',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
              styleClass: 'btn-floating btn waves-effect light-green darken-1' },
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onEdit: this.onEdit.bind(this),
            onDelete: this.onDelete.bind(this)
        }
    };

    departments: any[] = [];
    carriers: any[] = [];

    geSubs: any;
    gdSubs: any;

    permissions = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: EmployeeService,
        private departmentService: DepartmentService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
          permissionsSubs.unsubscribe();
          this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
          if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
          else this.allowed = true;
        });

        this.loadEmployees() ;
        /* console.time('load');
        let sub = service.getEmployees().subscribe(employees => {
            sub.unsubscribe();
            employees.map((employee, index) => {
                let internalKey = `2019-${employee.internalKey}`;
                let active = 2019;
                //console.log(employee.id$);
                service.putEmployee({internalKey, active}, employee.id$);
            });
        }) */
    }

    ngOnInit() {

    }
    ngOnDestroy(){
        //this.geSubs.unsubscribe();
    }


    //qrBatch S
    /* @ViewChildren('qrCode') qrDivs: QueryList<QRCodeComponent>;
    qrDatas: {[id: string]: string};
    get a_qrDatas(){ return Object.values(this.qrDatas) }
    idToImgSrc: {[id: string]: string} = {}; 
    onQrBatch(){
        this.qrDivs.map(({qrcode}, index) =>{
            let full = qrcode._oQRCode.dataList[0].data;
            let id: string = full.split("\n")[0].split(" ")[1];
            this.idToImgSrc[id] = qrcode._oDrawing._elImage.currentSrc;
            
        });
        let a = Object.keys(this.qrDatas); //[id]
        let l = a.length;
        let THIS = this;
        alert(`Total: ${l}`);
        run(0);
        function run(index){
            if(index >= l) return;
            console.log('trying ' + a[index] + ', ' + index + '/' + l);
            //if(index%200 == 0)
            let blob: any;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", THIS.idToImgSrc[a[index]]);
            xhr.responseType = "blob";
            xhr.onload = () => {
                blob = xhr.response;
                blob.name = 'webcamPicture.jpeg';
                let file: File = <File> blob;
                var currentUpload: Upload = new Upload(file);
                THIS.service.uploadQR(currentUpload, a[index], () => { run(index + 1) });
            };
            xhr.send();
        }
    } */
    //qrBatch E
    loadEmployees() {
        this.gdSubs = this.departmentService.getDepartments().subscribe(tempDepartments => {
            this.gdSubs.unsubscribe();

            for (const idx in tempDepartments) {
                this.departments[tempDepartments[idx].id$] = tempDepartments[idx].name;
            }

            this.geSubs = this.service.getEmployees().subscribe(tempEmployees => {/* 
                localStorage.employeesJson = JSON.stringify( tempEmployees.reduce((acc, cur) => {
                    acc[cur.internalKey] = cur.id$;
                    return acc;
                }, {}) ) */
                
                //qrBatch S
                //let temp = []; for(let i = 0; i < 5; i++) temp[i] = tempEmployees[i];
                /* this.qrDatas = tempEmployees.reduce((acc, employee: EmployeeId) => {
                    acc[employee.id] = `Id: ${employee.id}\nLlave interna: ${employee.internalKey}\nNombre: ${employee.name} ${employee.lastName}`;
                    return acc;
                }, {});
                if(1) return //console.log(this.a_qrDatas); */
                //qrBatch E

                this.employees = [];

                for (const idx in tempEmployees) {
                    let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                    this.carriers[tempEmployees[idx].id$] = employeeDisplayValue;
                }

                for (const idx in tempEmployees) {
                    if (tempEmployees[idx].admissionDate) {
                        tempEmployees[idx].admissionDate = Utils.convertDatefromStringtoISOString(tempEmployees[idx].admissionDate);
                    }

                    if (!tempEmployees[idx].internalKey) {
                        tempEmployees[idx].internalKey = '';
                    }

                    if (Math.floor(tempEmployees[idx].transportArrive) !== 3) {
                        switch (tempEmployees[idx].transportArrive) {
                            case 1:
                                tempEmployees[idx].transportArriveName = 'Por su propio medio';
                                break;
                            case 2:
                                tempEmployees[idx].transportArriveName = 'Duerme en las instalaciones';
                                break;
                            case 4:
                                tempEmployees[idx].transportArriveName = 'Transporte de la empresa';
                                break;
                            default:
                                tempEmployees[idx].transportArriveName = 'No especificado';
                                break;
                        }

                        tempEmployees[idx].carrierName = 'N/A';
                    } else {
                        tempEmployees[idx].transportArriveName = tempEmployees[idx].transportArrive == 3 ? 'Es trasladado por un transportista local' : 'Es transladado por un transportista foráneo';
                        tempEmployees[idx].carrierName = this.carriers[tempEmployees[idx].carrierId];
                    }

                    if (tempEmployees[idx].departmentId) {
                        tempEmployees[idx].departmentName = this.departments[tempEmployees[idx].departmentId];
                    } else {
                        tempEmployees[idx].departmentName = '-';
                    }

                    this.employees.push(tempEmployees[idx]);
                }

                if(localStorage.re_emp__page){
                    this.page = +localStorage.re_emp__page;
                }
                this.data = this.employees;
                this.length = this.data.length;
                console.log(this.length);
                this.onChangeTable(this.config);
            });

        });
    }

    onCellClick(data: any): any {
        this.router.navigate(['/vw_employee/' + data.row.id$]);
    }

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.router.navigate(['/add_employee']);
    }

    onEdit(data: any) {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        this.router.navigate(['/edt_employee/', data.row.id$], { queryParams: { returnUrl: '/employees' } });
    }

    onDelete(data: any) {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.service.delEmployee(data.row.id$).then(res => {
            this.loadEmployees();
        });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
		localStorage.re_emp__page = `${page.page}`;
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
